import Item, { FinderItens, RetornoItem } from 'Interface/Itens';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { paramsParaString } from '../utils';
import { tag as tagHolerite } from './Holerites';

const tag = 'Itens';

const url = '/itens';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, tagHolerite],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarItens: construtor.query<FinderItens, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.itens
            ? [
                ...resultado.itens.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarItem: construtor.query<
        RetornoItem,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarItem: construtor.mutation<Item, Partial<Item>>({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: dados,
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarItem: construtor.mutation<
        Item,
        Partial<Item> & Pick<Item, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerItem: construtor.mutation<Item, Partial<Item> & Pick<Item, 'id'>>({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id, holerite_id }) =>
          !erro
            ? [
                { type: tag, id },
                { type: tagHolerite, id: holerite_id },
              ]
            : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarItensQuery,
  useRecuperarItemQuery,
  useAdicionarItemMutation,
  useEditarItemMutation,
  useRemoverItemMutation,
} = apiExtendida;
